<template>
  <div>
    <serveur-info :erreur="error" />
    <form @submit.prevent="validateBeforeSubmit">
      <my-notification :icon="'calendar'">
        <template #title>
          {{ $t('compCarbonFormsBoundariesBoundary.title-1') }}
        </template>
        {{ $t('compCarbonFormsBoundariesBoundary.info-1') }}
        {{ currentYear - 2 }}
        {{ $t('compCarbonFormsBoundariesBoundary.info-2') }} {{ currentYear
        }}{{ $t('compCarbonFormsBoundariesBoundary.info-3') }}
        {{ currentYear - 2 }}).
        <br />
        {{ $t('compCarbonFormsBoundariesBoundary.info-4') }}
        <br />
        {{ $t('compCarbonFormsBoundariesBoundary.info-5') }}
        <br />
        <br />
        {{ $t('compCarbonFormsBoundariesBoundary.info-6') }}
        <br />
        <br />
        <div class="columns">
          <div class="column">
            <b-field
              :label="$t('compCarbonFormsBoundariesBoundary.field-1') + ' *'"
              :type="{ 'is-danger': errors.has('year') }"
              :message="errors.first('year')"
            >
              <b-select
                :placeholder="
                  $t('compCarbonFormsBoundariesBoundary.field-1') + ' *'
                "
                icon="calendar"
                v-validate="'required'"
                name="year"
                expanded
                :disabled="isSubmitted"
                v-model="year"
              >
                <option
                  :disabled="year.disabled"
                  v-for="(year, index) in availableYears"
                  :value="year.value"
                  :key="index"
                >
                  {{ year.value }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column">
            <b-field
              :label="$t('compCarbonFormsBoundariesBoundary.field-2') + ' *'"
              :type="{ 'is-danger': errors.has('budget') }"
              :message="errors.first('budget')"
            >
              <b-input
                name="budget"
                v-model.number="budget"
                :placeholder="
                  $t('compCarbonFormsBoundariesBoundary.field-2') + ' *'
                "
                v-validate="'required|numeric|min_value:1'"
                type="number"
                expanded
                min="0"
                icon="eur"
                :disabled="isSubmitted"
              />
            </b-field>
          </div>
        </div>
      </my-notification>
      <br />
      <my-notification :icon="'group'">
        <template #title>
          {{ $t('compCarbonFormsBoundariesBoundary.title-2') }}
        </template>
        <div class="columns">
          <div class="column is-9" style="margin-right: 20px">
            {{ $t('compCarbonFormsBoundariesBoundary.info-7') }}
            <br />
            {{ $t('compCarbonFormsBoundariesBoundary.info-8') }}
          </div>
          <div class="column">
            <nav
              class="level"
              style="
                border-left: 1px solid;
                margin-left: 30px;
                margin-top: 20px;
              "
            >
              <div class="level-item has-text-centered">
                <div>
                  <p class="heading">
                    {{ $t('compCarbonFormsBoundariesBoundary.field-4') }}
                  </p>
                  <p class="title">{{ total }}</p>
                </div>
              </div>
            </nav>
          </div>
        </div>
        <section>
          <b-field grouped group-multiline>
            <b-field
              v-for="position in ghgiStore.item.boundary.structure"
              :key="position.name"
              :label="$t(position.name)"
              :type="{ 'is-danger': errors.has(position.name) }"
              :message="errors.first(position.name)"
              expanded
            >
              <b-input
                :name="position.name"
                :disabled="isSubmitted"
                v-validate="'required|numeric'"
                v-model.number="position.number"
                @input="inputChanged"
                type="number"
                min="0"
              />
            </b-field>
          </b-field>
        </section>
      </my-notification>
      <br />
      <my-notification :icon="'pencil'">
        <template #title>
          {{ $t('compCarbonFormsBoundariesBoundary.field-3') }}
        </template>
        <editor v-model="description" />
      </my-notification>
      <br />
      <nav v-if="!isSubmitted" class="level">
        <div class="level-left"></div>
        <div class="level-right">
          <button
            type="submit"
            :disabled="isDisabled"
            class="level-item button is-primary"
            data-testid="ghgi-boundary-save"
          >
            <span class="icon is-small" v-if="authStore.isAuthenticated"
              ><i class="fa fa-save"></i
            ></span>
            <span class="icon is-small" v-else
              ><i class="fa fa-check"></i
            ></span>
            <span v-if="authStore.isAuthenticated">{{ $t('save') }}</span>
            <span v-else>{{ $t('validate') }}</span>
          </button>
        </div>
      </nav>
    </form>
  </div>
</template>

<script>
import { useAdminStore } from '@/stores/admin.js'
import { useAuthenticationStore } from '@/stores/authentication.js'
import { useGHGIStore } from '@/stores/ghgi.js'
import { useCoreStore } from '@/stores/core'

export default {
  name: 'GenericEntity',
  components: {
    editor: () => import('@/components/Editor.vue'),
    'my-notification': () => import('@/components/MyNotification.vue'),
    'serveur-info': () => import('@/components/ServeurInfo.vue')
  },
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    flags: {
      type: Object
    }
  },
  data () {
    return {
      error: '',
      hasBeenSavedOnce: false,
      editorEventOK: false
    }
  },
  setup () {
    const adminStore = useAdminStore()
    const authStore = useAuthenticationStore()
    const ghgiStore = useGHGIStore()
    const coreStore = useCoreStore()
    return { adminStore, authStore, ghgiStore, coreStore }
  },
  computed: {
    allGHGI: function () {
      return this.adminStore.allGHGI
    },
    positionTitles: function () {
      return this.coreStore.positionTitles
    },
    isSubmitted: function () {
      return this.ghgiStore.item.isSubmitted
    },
    currentYear: function () {
      return new Date().getFullYear()
    },
    availableYears: function () {
      let years = []
      let cYear = new Date().getFullYear() - 1
      let toYear = cYear - 10
      for (let i = cYear; i >= toYear; i--) {
        let year = this.allGHGI.filter((obj) => parseInt(obj.year) === i)
        years.push({
          value: i,
          disabled: year.length !== 0
        })
      }
      return years
    },
    validSavedIcon: function () {
      let icon = null
      if (this.authStore.isAuthenticated) {
        icon = 'save'
      } else {
        icon = 'check'
      }
      return icon
    },
    id: function () {
      return this.ghgiStore.item.id
    },
    year: {
      get: function () {
        return this.ghgiStore.item.year
      },
      set: function (year) {
        this.ghgiStore.updateYear(year)
        this.inputChanged()
      }
    },
    budget: {
      get: function () {
        return this.ghgiStore.item.boundary.budget
      },
      set: function (budget) {
        this.ghgiStore.updateNBudget(budget)
        this.inputChanged()
      }
    },
    description: {
      get: function () {
        return this.ghgiStore.item.description
      },
      set: function (description) {
        this.ghgiStore.updateDescription(description)
        if (!this.editorEventOK) {
          this.editorEventOK = true
        } else {
          this.inputChanged()
        }
      }
    },
    isDisabled () {
      let toReturn = true
      if (this.hasBeenSavedOnce) {
        toReturn = !this.flags.isModified || this.total === 0
      } else {
        toReturn = this.flags.isValid || this.total === 0
      }
      return toReturn
    },
    total () {
      return this.ghgiStore.item.boundary.workforce
    }
  },
  methods: {
    numberChanged (positionName, number) {
      this.ghgiStore.item.boundary.structure.setNumber(
        positionName,
        parseInt(number)
      )
    },
    inputChanged () {
      if (this.hasBeenSavedOnce || this.flags.isValid) {
        this.$emit('is-valid', false)
        this.$emit('is-modified', true)
        this.error = ''
      }
    },
    validateBeforeSubmit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.authStore.isAuthenticated) {
            const loadingComponent = this.$buefy.loading.open({
              container: null
            })
            this.ghgiStore
              .saveGHGI()
              .then((data) => {
                loadingComponent.close()
                this.$emit('is-valid', true)
                this.$emit('is-modified', false)
                this.error = ''
                window.scrollTo(0, 0)
                this.$buefy.toast.open({
                  type: 'is-light',
                  message: this.$t('compCarbonFormsBoundariesBoundary.save-msg')
                })
                this.hasBeenSavedOnce = true
                this.ghgiStore.set(data.id).then((data) => {
                  this.$router.push('/ges-1point5/' + this.id).catch(() => {})
                })
              })
              .catch((error) => {
                loadingComponent.close()
                this.$emit('is-valid', false)
                this.error = error.response.data
                this.$emit('is-modified', false)
              })
          } else {
            this.$emit('is-valid', true)
            this.$emit('is-modified', false)
            this.hasBeenSavedOnce = true
          }
        }
      })
    }
  },
  mounted: function () {}
}
</script>
